"use client";

import Image from "./image";
import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";
import { cases } from "../lib/site-data";

export function CaseFilter() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedCase = cases[selectedIndex];

  return (
    <div className="case-showcase">
      <AnimatePresence initial={false} mode="wait">
        <motion.article
          animate={{ opacity: 1, scale: 1 }}
          className="case-feature"
          exit={{ opacity: 0, scale: 1.01 }}
          initial={{ opacity: 0, scale: 0.99 }}
          key={selectedCase.title}
          transition={{ duration: 0.18, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.div
            animate={{ clipPath: "polygon(0 0, 120% 0, 100% 100%, 0 100%)" }}
            className="case-feature-image"
            exit={{ clipPath: "polygon(100% 0, 120% 0, 100% 100%, 80% 100%)" }}
            initial={{ clipPath: "polygon(0 0, 0 0, -20% 100%, -20% 100%)" }}
            transition={{ duration: 0.24, ease: [0.22, 1, 0.36, 1] }}
          >
            <Image
              src={selectedCase.image}
              alt=""
              fill
              sizes="(max-width: 900px) 100vw, 62vw"
            />
          </motion.div>
          <div className="case-feature-copy">
            <span>{selectedCase.category}</span>
            <h2>{selectedCase.title}</h2>
            <p>{selectedCase.subtitle}</p>
            <div className="case-deliverables">
              {selectedCase.deliverables.map((value) => (
                <span key={value}>{value}</span>
              ))}
            </div>
            <div className="case-status">
              {selectedCase.facts.map(({ label, value }) => (
                <div key={label}>
                  <small>{label}</small>
                  <strong>{value}</strong>
                </div>
              ))}
            </div>
          </div>
        </motion.article>
      </AnimatePresence>

      <div className="case-project-index" role="tablist" aria-label="选择案例">
        {cases.map((item, index) => (
          <button
            aria-selected={selectedIndex === index}
            key={item.title}
            onClick={() => setSelectedIndex(index)}
            onFocus={() => setSelectedIndex(index)}
            onMouseEnter={() => setSelectedIndex(index)}
            role="tab"
            type="button"
          >
            <span>{String(index + 1).padStart(2, "0")}</span>
            <strong>{item.title}</strong>
            <small>{item.category}</small>
            {selectedIndex === index && (
              <motion.i layoutId="case-project-indicator" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
